import React, { Fragment, useState, useContext } from 'react'
import { Tabs } from 'antd'
import { AppContext } from 'AppContext'
import CustomMeta from 'components/CustomMeta'
import { ArrowLeftOutlined } from '@ant-design/icons'

import '../index.css'
import history from 'CustomHistory'
import DepartmentTable from './Department'
import TeamTable from './Team'
import MembersTable from './Members'
import EscalationsTable from './Escalations'
import KeywordMapping from './KeywordMapping'
import PrioritySlaConfigTable from './PriorityConfig'
import { GET_TEAM_MEMBERS } from './graphql/Queries'
import { useQuery } from '@apollo/react-hooks'

export default function () {
  const {
    state: {
      isClient,
      isVerificationDone,
      isMobile,
    },
  } = useContext(AppContext)

    const { data, loading, refetch } = useQuery(GET_TEAM_MEMBERS)
  

  const [activeTab, setActiveTab] = useState('Department')
  const tabItems = [
    { key: 'Department', label: 'Department', content: <DepartmentTable /> },
    { key: 'Team', label: 'Team', content: <TeamTable /> },
    {
      key: 'Members',
      label: 'Members',
      content: <MembersTable data={data} loading={loading} refetch={refetch}/>,
    },
    {
      key: 'KeywordMapping',
      label: 'Keyword Mapping',
      content: <KeywordMapping />,
    },
    {
      key: 'Escalations',
      label: 'Escalations',
      content: <EscalationsTable />,
    },
    {
      key: 'Priority Config',
      label: 'Priority Config',
      content: <PrioritySlaConfigTable />,
    },
  ]

  return (
    <Fragment>
      <CustomMeta title='Tickets' />
      <div className='main_dashboard_div' style={{ padding: '20px 40px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            width: '100%',
          }}
        >
          <div
            style={{
              fontSize: isMobile ? '18px' : '24px',
              fontWeight: '600',
              lineHeight: '26px',
              letterSpacing: '-0.02em',
              textAlign: 'left',
              color: '#181C32',
              display: 'flex',
              gap: '20px',
            }}
          >
            {isClient && !isVerificationDone ? (
              <div
                className='back_icon_for_advisory'
                onClick={() => history.goBack()}
              >
                <ArrowLeftOutlined />
              </div>
            ) : (
              ''
            )}
            Settings
          </div>
        </div>

        {/* Settings Tabs */}
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          style={{ marginBottom: 16 }}
        >
          {tabItems.map((tab) => (
            <Tabs.TabPane tab={tab.label} key={tab.key}>
              {activeTab === tab.key && tab.content}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </Fragment>
  )
}
